import { useCopy } from '@/i18n';
import { Section } from './Section';
import { hasSplitTitle, renderSplitTitle, type SplitTitleCopy } from './titleCopy';

type FinalCtaCopy = SplitTitleCopy & {
  eyebrow?: string;
  subtitle?: string;
  lead?: string;
};

type Props = { ctaPrimary: string; ctaSecondary: string };

export function FinalCTA({ ctaPrimary, ctaSecondary }: Props) {
  const copy = useCopy();
  const c = copy<FinalCtaCopy>('final_cta') ?? {};
  return (
    <Section id="final-cta" bg="ink" route routeSeed={2}>
      <div style={{ textAlign: 'center', maxWidth: 760, margin: '0 auto', color: 'var(--paper)' }}>
        {c.eyebrow ? <span className="eyebrow">{c.eyebrow}</span> : null}
        {hasSplitTitle(c) ? (
          <h2 className="h-section" style={{ marginTop: 14, color: 'var(--paper)' }}>
            {renderSplitTitle(c, (accent) => (
              <span className="accent">{accent}</span>
            ))}
          </h2>
        ) : null}
        {c.lead || c.subtitle ? (
          <p className="lead" style={{ marginTop: 20, color: 'var(--paper)' }}>
            {c.lead ?? c.subtitle}
          </p>
        ) : null}
        <div
          style={{
            display: 'flex',
            gap: 14,
            marginTop: 32,
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <a href="/signup" className="btn btn-primary btn-arrow">
            {ctaPrimary}
          </a>
          <a href="#situations" className="btn btn-ghost" style={{ color: 'var(--paper)' }}>
            {ctaSecondary}
          </a>
        </div>
      </div>
    </Section>
  );
}
